/* eslint-disable no-empty-pattern */
import PubSub from 'pubsub-js';
import React, { useEffect, useState } from 'react';
import { AccessRoles } from '../../..';
import { config_baseURL } from '../../../api';
import { Title } from '../../CampaignView/CampaignConfigurator/CampaignConfigurator.Styles';
import { AccountSelector } from '../../commons/AccountSelector';
import { BottomSlidingPane } from '../../commons/BottomSlidingPane';
import { SnackbarComponent } from '../../commons/SnackbarComponent';
import { CampaignOversightDetails } from '../CampaignOversightDetails';
import { CampaignOversightListTable } from './CampaignOversightListTable';
import { ButtonWrapper, TitleWrapper, Wrapper, } from './CampaignOversightMainView.Styles';
export var CampaignOversightMainView = function (_a) {
    var scheduleExecutions = _a.scheduleExecutions, selectedAccount = _a.selectedAccount, setAccount = _a.setAccount, didSucceed = _a.didSucceed, accessLevel = _a.accessLevel, getScheduleExecutions = _a.getScheduleExecutions, controlScheduleExecution = _a.controlScheduleExecution, tempDialerDefaults = _a.dialerDefaults, getDialerDefaults = _a.getDialerDefaults, schedules = _a.schedules, getSchedules = _a.getSchedules;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var _c = useState(null), selectedRow = _c[0], setSelectedRow = _c[1];
    var _d = useState(scheduleExecutions), rowData = _d[0], setRowData = _d[1];
    var _e = useState(false), openSnack = _e[0], setOpenSnack = _e[1];
    var _f = useState(''), snackMessage = _f[0], setSnackMessage = _f[1];
    var _g = useState(''), title = _g[0], setTitle = _g[1];
    var _h = useState('success'), severity = _h[0], setSeverity = _h[1];
    var _j = useState(tempDialerDefaults), dialerDefaults = _j[0], setDialerDefaults = _j[1];
    var _k = useState(), accountURL = _k[0], setAccountURL = _k[1];
    useEffect(function () {
        if (Array.isArray(tempDialerDefaults)) {
            var temp = tempDialerDefaults.find(function (tg) { return tg.prjacc.url === config_baseURL(); });
            setDialerDefaults(temp);
        }
        else {
            setDialerDefaults(tempDialerDefaults);
        }
    }, [accountURL, tempDialerDefaults]);
    var handlePaneClose = function () {
        PubSub.publish('campaign_oversight_pane_status', false);
    };
    var handleOpenSnack = function () {
        setOpenSnack(true);
    };
    useEffect(function () {
        PubSub.subscribe('control_schedule_execution', function (topic, msg) {
            setSnackMessage(msg.message);
            setSeverity(msg.severity);
            setOpenSnack(true);
        });
        return function () { return PubSub.unsubscribe('control_schedule_execution'); };
    }, []);
    useEffect(function () {
        PubSub.subscribe('campaign_oversight_form_status', function (topic, msg) {
            setOpen(!msg);
        });
        if (scheduleExecutions.length < 1) {
            getScheduleExecutions();
            if (rowData !== scheduleExecutions) {
                setRowData(scheduleExecutions);
            }
        }
    }, []);
    useEffect(function () {
        getScheduleExecutions();
        getDialerDefaults();
        var interval = setInterval(function () {
            getScheduleExecutions();
        }, 5000);
        return function () { return clearInterval(interval); };
    }, [accountURL]);
    useEffect(function () {
        setRowData(scheduleExecutions);
    }, [scheduleExecutions]);
    var handleRowClick = function (rowId) {
        var scheduleExecution = scheduleExecutions === null || scheduleExecutions === void 0 ? void 0 : scheduleExecutions.find(function (se) { return se.ScheduleExecutionId === rowId; });
        setSelectedRow(scheduleExecution);
        setTitle((scheduleExecution === null || scheduleExecution === void 0 ? void 0 : scheduleExecution.ScheduleName) || '');
        setOpen(true);
    };
    var handleDiscard = function () {
        setOpen(false);
        setSelectedRow(null);
        localStorage.setItem('onEditMode', '0');
    };
    var alertReadOnly = function () {
        setSnackMessage('Access Denied');
        setSeverity('info');
        setOpenSnack(true);
    };
    var handleCloseSnack = function (_event, reason) {
        setOpenSnack(false);
    };
    var handleUpdateCallback = function (data) {
        var status = data.action.type;
        if (status === 'CONTROL_SCHEDULE_EXECUTION_FULFILLED') {
            setSnackMessage('Campaign Updated!');
            setSeverity('success');
        }
        else if (status === 'CONTROL_SCHEDULE_EXECUTION_REJECTED') {
            setSnackMessage('Campaign Update Failed!');
            setSeverity('error');
        }
        setOpenSnack(true);
    };
    return (React.createElement(Wrapper, null,
        React.createElement(TitleWrapper, null,
            React.createElement(Title, { variant: 'h6' }, "Campaign Oversight"),
            React.createElement(ButtonWrapper, null,
                React.createElement(AccountSelector, { initialValue: selectedAccount, onValueChange: function (data) { return setAccount(data); }, disabled: open }))),
        React.createElement(BottomSlidingPane, { title: title, topOffSet: 100, open: open, readonly: accessLevel === AccessRoles.READ_ONLY, onClose: function () { return handlePaneClose(); }, component: React.createElement(CampaignOversightDetails, { dialerDefaults: dialerDefaults, schedules: schedules, onDiscardClick: function () { return handleDiscard(); }, selectedScheduleExecution: selectedRow, controlScheduleExecution: function (action, scheduleExecutionId, callback, pacing) {
                    return controlScheduleExecution(action, scheduleExecutionId, function (data) {
                        handleUpdateCallback(data);
                        callback(data);
                    }, pacing);
                }, onAccountChange: function (url) { return setAccountURL(url); } }) },
            React.createElement(CampaignOversightListTable, { onRowClick: function (row) {
                    if (accessLevel === AccessRoles.READ_ONLY) {
                        alertReadOnly();
                    }
                    else {
                        handleRowClick(row);
                    }
                }, rowData: rowData, accessLevel: accessLevel, controlScheduleExecution: function (action, scheduleExecutionId, callback, pacing) {
                    return controlScheduleExecution(action, scheduleExecutionId, function (data) {
                        handleUpdateCallback(data);
                        callback(data);
                    }, pacing);
                }, accountURL: accountURL })),
        React.createElement(SnackbarComponent, { anchorOrigin: {
                vertical: 'top',
                horizontal: 'center'
            }, open: openSnack, autoHideDuration: 5000, onAlertClose: handleCloseSnack, alertMessage: snackMessage, severity: severity })));
};
CampaignOversightMainView.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=CampaignOversightMainView.js.map